import { SCHEDULER } from "../../../utils/ServiceUtils";
import { ServiceBase } from "../ServiceBase";
import { ICreateTaskRequest } from "./requests/CreateTaskRequest";
import { ICreateIssueRequest } from "./requests/CreateIssueRequest";
import { ICreateTimesheetRequest } from "./requests/CreateTimesheetRequest";
import { IDeleteTaskRequest } from "./requests/DeleteTaskRequest";
import { IDeleteIssueRequest } from "./requests/DeleteIssueRequest";
import { IDeleteTimesheetRequest } from "./requests/DeleteTimesheetRequest";
import { IEvaluateTimesheetRequest } from "./requests/EvaluateTimesheetRequest";
import { IGetSchedulerSettingsRequest } from "./requests/GetSchedulerSettingsRequest";
import { IGetTypeOfWorkForContextRequest } from "./requests/GetTypeOfWorkForContextRequest";
import { IListEventRequest } from "./requests/ListEventRequest";
import { IListTaskRequest } from "./requests/ListTaskRequest";
import { IListIssueRequest } from "./requests/ListIssueRequest";
import { ITaskTemplateListRequest } from "./requests/TaskTemplateListRequest";
import { IListTimesheetRequest } from "./requests/ListTimesheetRequest";
import { IUpdateTaskRequest } from "./requests/UpdateTaskRequest";
import { IUpdateIssueRequest } from "./requests/UpdateIssueRequest";
import { IUpdateTimesheetRequest } from "./requests/UpdateTimesheetRequest";
import { CreateTaskResponse } from "./responses/CreateTaskResponse";
import { CreateIssueResponse } from "./responses/CreateIssueResponse";
import { CreateTimesheetResponse } from "./responses/CreateTimesheetResponse";
import { DeleteTaskResponse } from "./responses/DeleteTaskResponse";
import { DeleteIssueResponse } from "./responses/DeleteIssueResponse";
import { DeleteTimesheetResponse } from "./responses/DeleteTimesheetResponse";
import { EvaluateTimesheetResponse } from "./responses/EvaluateTimesheetResponse";
import { GetSchedulerSettingsResponse } from "./responses/GetSchedulerSettingsResponse";
import { GetTypeOfWorkForContextResponse } from "./responses/GetTypeOfWorkForContextResponse";
import { ListEventResponse } from "./responses/ListEventResponse";
import { ListTaskResponse } from "./responses/ListTaskResponse";
import { ListIssueResponse } from "./responses/ListIssueResponse";
import { TaskTemplateListResponse } from "./responses/TaskTemplateListResponse";
import { ListTimesheetResponse } from "./responses/ListTimesheetResponse";
import { UpdateTaskResponse } from "./responses/UpdateTaskResponse";
import { UpdateIssueResponse } from "./responses/UpdateIssueResponse";
import { UpdateTimesheetResponse } from "./responses/UpdateTimesheetResponse";
import { ICreateEventRequest } from "./requests/CreateEventRequest";
import { CreateEventResponse } from "./responses/CreateEventResponse";
import { IUpdateEventRequest } from "./requests/UpdateEventRequest";
import { UpdateEventResponse } from "./responses/UpdateEventResponse";
import { IGetEventRequest } from "./requests/GetEventRequest";
import { GetEventResponse } from "./responses/GetEventResponse";
import { IDeleteEventRequest } from "./requests/DeleteEventRequest";
import { DeleteEventResponse } from "./responses/DeleteEventResponse";
import { ICheckConflictsRequest } from "./requests/CheckConflictsRequest";
import { CheckConflictsResponse } from "./responses/CheckConflictsResponse";
import { IGetTaskRequest } from "./requests/GetTaskRequest";
import { GetTaskResponse } from "./responses/GetTaskResponse";
import { IGetIssueRequest } from "./requests/GetIssueRequest";
import { GetIssueResponse } from "./responses/GetIssueResponse";
export interface ISchedulerService {
    getSchedulerSettings(request: IGetSchedulerSettingsRequest): Promise<GetSchedulerSettingsResponse>;
    listTimeSheet(request: IListTimesheetRequest): Promise<ListTimesheetResponse>;
    createTimeSheet(request: ICreateTimesheetRequest): Promise<CreateTimesheetResponse>;
    updateTimeSheet(request: IUpdateTimesheetRequest): Promise<UpdateTimesheetResponse>;
    deleteTimeSheet(request: IDeleteTimesheetRequest): Promise<DeleteTimesheetResponse>;
    getTypeOfWorkForContext(request: IGetTypeOfWorkForContextRequest): Promise<GetTypeOfWorkForContextResponse>;
    evaluateTimeSheet(request: IEvaluateTimesheetRequest): Promise<EvaluateTimesheetResponse>;

    createTask(request: ICreateTaskRequest): Promise<CreateTaskResponse>;
    createIssue(request: ICreateIssueRequest): Promise<CreateIssueResponse>;
    updateTask(request: IUpdateTaskRequest): Promise<UpdateTaskResponse>;
    updateIssue(request: IUpdateIssueRequest): Promise<UpdateIssueResponse>;
    listTask(request: IListTaskRequest): Promise<ListTaskResponse>;
    listIssue(request: IListIssueRequest): Promise<ListIssueResponse>;
    taskTemplateList(request: ITaskTemplateListRequest): Promise<TaskTemplateListResponse>;
    deleteTask(request: IDeleteTaskRequest): Promise<DeleteTaskResponse>;
    deleteIssue(request: IDeleteIssueRequest): Promise<DeleteIssueResponse>;
    getTask(request: IGetTaskRequest): Promise<GetTaskResponse>;
    getIssue(request: IGetIssueRequest): Promise<GetIssueResponse>;
    listEvent(request: IListEventRequest): Promise<ListEventResponse>;
    createEvent(request: ICreateEventRequest): Promise<CreateEventResponse>;
    updateEvent(request: IUpdateEventRequest): Promise<UpdateEventResponse>;
    getEvent(request: IGetEventRequest): Promise<GetEventResponse>;
    deleteEvent(request: IDeleteEventRequest): Promise<DeleteEventResponse>;

    checkConflicts(request: ICheckConflictsRequest): Promise<CheckConflictsResponse>;
}

export class SchedulerService extends ServiceBase implements ISchedulerService {
    private _addRootElementForItem(xml: string, rootElement: string = 'ListTimesheetResponse'): string {
        xml = xml.replaceAll('</name><ITEM>', '</name><ITEMS><ITEM>');
        xml = xml.replaceAll(`</ITEM></ns1:${rootElement}>`, `</ITEM></ITEMS></ns1:${rootElement}>`);
        return xml;
    }

    public async getSchedulerSettings(request: IGetSchedulerSettingsRequest): Promise<GetSchedulerSettingsResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.getSchedulerSettings, request.cancelSource));
            response = this._addRootElementForItem( tmp_response.data, 'GetSchedulerSettingsResponse');
            await this.updateCache(SCHEDULER.getSchedulerSettings, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.getSchedulerSettings, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).GetSchedulerSettingsResponse as GetSchedulerSettingsResponse;
        if(!super._checkErrors(parsedResponse)){

        }else{
            parsedResponse.ITEMS = parsedResponse.ITEMS.filter((item) => ((+item.ITEM.validFor) & request.itemType) !== 0);
        }

        return parsedResponse;        
    }

    public async listTimeSheet(request: IListTimesheetRequest): Promise<ListTimesheetResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.listTimeSheet, request.cancelSource));
            response =  this._addRootElementForItem(tmp_response.data);
            await this.updateCache(SCHEDULER.listTimeSheet, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.listTimeSheet, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).ListTimesheetResponse as ListTimesheetResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async createTimeSheet(request: ICreateTimesheetRequest): Promise<CreateTimesheetResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.createTimeSheet, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.createTimeSheet, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.createTimeSheet, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateTimesheetResponse as CreateTimesheetResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async updateTimeSheet(request: IUpdateTimesheetRequest): Promise<UpdateTimesheetResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.updateTimeSheet, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.updateTimeSheet, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.updateTimeSheet, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateTimesheetResponse as UpdateTimesheetResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async deleteTimeSheet(request: IDeleteTimesheetRequest): Promise<DeleteTimesheetResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.deleteTimeSheet, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.deleteTimeSheet, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.deleteTimeSheet, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).DeleteTimesheetResponse as DeleteTimesheetResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async getTypeOfWorkForContext(request: IGetTypeOfWorkForContextRequest): Promise<GetTypeOfWorkForContextResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.getTypeOfWorkForContext, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.getTypeOfWorkForContext, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.getTypeOfWorkForContext, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).GetTypeOfWorkForContextResponse as GetTypeOfWorkForContextResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async evaluateTimeSheet(request: IEvaluateTimesheetRequest): Promise<EvaluateTimesheetResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.evaluateTimeSheet, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.evaluateTimeSheet, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.evaluateTimeSheet, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).EvaluateTimesheetResponse as EvaluateTimesheetResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async createTask(request: ICreateTaskRequest): Promise<CreateTaskResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.createTask, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.createTask, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.createTask, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateTaskResponse as CreateTaskResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async createIssue(request: ICreateIssueRequest): Promise<CreateIssueResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.createIssue, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.createIssue, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.createIssue, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateIssueResponse as CreateIssueResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async updateTask(request: IUpdateTaskRequest): Promise<UpdateTaskResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.updateTask, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.updateTask, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.updateTask, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateTaskResponse as UpdateTaskResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async updateIssue(request: IUpdateIssueRequest): Promise<UpdateIssueResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.updateIssue, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.updateIssue, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.updateIssue, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateIssueResponse as UpdateIssueResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listTask(request: IListTaskRequest): Promise<ListTaskResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.listTask, request.cancelSource));
            response = this._addRootElementForItem(tmp_response.data, 'ListTaskResponse');
            await this.updateCache(SCHEDULER.listTask, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.listTask, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).ListTaskResponse as ListTaskResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async deleteTask(request: IDeleteTaskRequest): Promise<DeleteTaskResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.deleteTask, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.deleteTask, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.deleteTask, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).DeleteTaskResponse as DeleteTaskResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async deleteIssue(request: IDeleteIssueRequest): Promise<DeleteIssueResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.deleteIssue, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.deleteIssue, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.deleteIssue, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).DeleteIssueResponse as DeleteIssueResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listIssue(request: IListIssueRequest): Promise<ListIssueResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.listIssue, request.cancelSource));
            response = this._addRootElementForItem(tmp_response.data, 'ListIssueResponse');
            await this.updateCache(SCHEDULER.listIssue, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.listIssue, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).ListIssueResponse as ListIssueResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async taskTemplateList(request: ITaskTemplateListRequest): Promise<TaskTemplateListResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.taskTemplateList, request.cancelSource));
            response = this._addRootElementForItem(tmp_response.data, 'TaskTemplateListResponse');
            await this.updateCache(SCHEDULER.taskTemplateList, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.taskTemplateList, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).TaskTemplateListResponse as TaskTemplateListResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listEvent(request: IListEventRequest): Promise<ListEventResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.listEvent, request.cancelSource));
            response = this._addRootElementForItem(tmp_response.data, 'ListEventResponse');
            await this.updateCache(SCHEDULER.listEvent, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.listEvent, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response,['ITEM', 'USER']).ListEventResponse as ListEventResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async createEvent(request: ICreateEventRequest): Promise<CreateEventResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.createEvent, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.createEvent, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.createEvent, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CreateEventResponse as CreateEventResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async updateEvent(request: IUpdateEventRequest): Promise<UpdateEventResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.updateEvent, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.updateEvent, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.updateEvent, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).UpdateEventResponse as UpdateEventResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async getEvent(request: IGetEventRequest): Promise<GetEventResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.getEvent, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.getEvent, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.getEvent, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).GetEventResponse as GetEventResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async deleteEvent(request: IDeleteEventRequest): Promise<DeleteEventResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.deleteEvent, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.deleteEvent, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.deleteEvent, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).DeleteEventResponse as DeleteEventResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async checkConflicts(request: ICheckConflictsRequest): Promise<CheckConflictsResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.checkConflicts, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.checkConflicts, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.checkConflicts, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).CheckConflictsResponse as CheckConflictsResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async getTask(request: IGetTaskRequest): Promise<GetTaskResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.getTask, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.getTask, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.getTask, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).GetTaskResponse as GetTaskResponse;
        if(!super._checkErrors(parsedResponse)){
        };
        return parsedResponse;
    }

    public async getIssue(request: IGetIssueRequest): Promise<GetIssueResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), SCHEDULER.getIssue, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(SCHEDULER.getIssue, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(SCHEDULER.getIssue, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).GetIssueResponse as GetIssueResponse;
        if(!super._checkErrors(parsedResponse)){
        };
        return parsedResponse;
    }
}
